export enum LeaveType {
    Paid = 1,
    Unpaid = 2,
    Compensation = 3
}
